import * as React from 'react';

import {Routing} from 'nutshell-core/routing';

import {AccountAvatar} from 'shells/avatar/account-avatar';
import {TrashRegularIcon} from 'shells/icon/svg/trash-regular-icon';
import {AccountCard} from 'shells/peep-cards/account-card/account-card';
import {PopoverList} from 'shells/popover/popover-list';

import type {ParentChildFragment} from 'nutshell-graphql-types';

type Props = {
    childAccounts: ParentChildFragment[];
    parentAccountId: string;
    onRemoveParent: (id: string) => void;
};

export const AllChildAccounts = (props: Props) => {
    const filter = Routing.param({
        fields: {
            accounts: 'name,parentAccount,contacts,lastContactedTime,address,accountType',
        },
        filter: {
            parentAccount: {
                data: [
                    {
                        data: props.parentAccountId,
                    },
                ],
            },
        },
    });

    const viewAllLink = `/companies?${filter}&view=list`;

    return (
        <PopoverList
            title='Child companies'
            viewAllLink={viewAllLink}
            collection={props.childAccounts}
            height={400}
            renderRow={(child) => (
                <AccountCard
                    key={child.id}
                    name={child.name}
                    icon={<AccountAvatar avatarUrl={child.avatarUrl} />}
                    accountUrl={child.htmlUrlPath}
                    description={child.description}
                    location={child.primaryAddressRegion}
                    toolbarProps={{
                        options: [
                            {
                                id: 'remove-association',
                                tooltipText: 'Remove association',
                                icon: TrashRegularIcon,
                                onClick: () => props.onRemoveParent(child.id),
                            },
                        ],
                    }}
                />
            )}
        />
    );
};
